module.exports = __webpack_public_path__ + "media/images/rewards/white-right-arrow-2b7d44edbb1a369448d8584623ce216c.svg";